(function(){
  const LEADERBOARD_API_BASE = '';

  const TILES = ['🐟','🦀','🐚','⚓','🦐','🌊'];
  const TROPHY = '🏆';
  const LEGEND_ICON = '🦈';
  const SIZE = 8;

  const boardEl = document.getElementById('cotd-board');
  const overlayEl = document.getElementById('cotd-overlay');
  const legendOverlayEl = document.getElementById('cotd-legend-overlay');
  const comboEl = document.getElementById('cotd-combo');
  const tideFlagEl = document.getElementById('cotd-tide-flag');
  const hotReelEl = document.getElementById('cotd-hotreel');
  const tensionFillEl = document.getElementById('cotd-tension-fill');
  const tensionPctEl = document.getElementById('cotd-tension-pct');
  const rankupEl = document.getElementById('cotd-rankup');
  const tutorialEl = document.getElementById('cotd-tutorial');

  let board = [];
  let selected = null;
  let moves = 20;
  let score = 0;
  let level = 1;
  let goalType = 0;
  let goalTarget = 15;
  let goalProgress = 0;
  let locked = false;
  let best = 0;

  let reverseTide = false;
  let movesSinceTideFlip = 0;
  let trophyAt = -1;
  let trophyCooldown = 2;
  let tension = 0;
  const TENSION_MAX = 6;
  let hotReelMovesLeft = 0;

  let legendAt = -1;
  let legendNextEligibleLevel = 1;
  let legendCatches = 0;
  let legendSpawnedThisLevel = false;

  let lifetimeScore = 0;
  let secretLevelPending = false;
  let inSecretLevel = false;
  let secretMultiplierActive = false;
  let hasShadowBadge = false;
  let shareUsedThisSession = false;
  let midnightDriftClears = 0;
  const CLEARS_NEEDED_FOR_BADGE = 3;

  let preSecretLegendNextEligibleLevel = 1;

  const secretStyle = document.createElement('style');
  secretStyle.textContent = `
    #cotd-root.secret-mode { background: #020106 !important; }
    #cotd-root.secret-mode #cotd-board { border-color: rgba(110,195,192,0.8); box-shadow: 0 0 40px rgba(110,195,192,0.3); }
    #cotd-root.secret-mode .cotd-tile { background: #080514; color: #6EC3C0; }
    #cotd-root.secret-mode #cotd-tide-flag { color: #C44A2A; }
    #cotd-secret-intro { position:fixed; inset:0; background:#020106; display:none; align-items:center; justify-content:center; z-index:500; text-align:center; padding:30px; box-sizing:border-box; }
    #cotd-secret-intro.active { display:flex; }
    #cotd-secret-intro .si { max-width:400px; }
    #cotd-secret-intro .si .eyebrow { font-family:'Cinzel',serif; font-size:10px; letter-spacing:0.5em; color:#6EC3C0; text-transform:uppercase; margin-bottom:16px; }
    #cotd-secret-intro .si h2 { font-family:'Playfair Display',serif; font-size:clamp(28px,6vw,46px); color:#F5F0E8; margin:0 0 16px; }
    #cotd-secret-intro .si .shark { font-size:80px; margin-bottom:16px; animation:secretShark 1.4s ease-in-out infinite; }
    @keyframes secretShark { 0%,100%{ transform:translateX(-12px) rotate(-6deg); } 50%{ transform:translateX(12px) rotate(6deg); } }
    #cotd-secret-intro .si p { font-family:'Crimson Text',serif; font-style:italic; font-size:16px; color:rgba(245,240,232,0.65); margin-bottom:28px; line-height:1.6; }
    #cotd-secret-intro .si button { font-family:'Cinzel',serif; font-weight:700; letter-spacing:0.2em; text-transform:uppercase; background:#6EC3C0; color:#020106; border:none; padding:16px 40px; cursor:pointer; font-size:13px; }
    #cotd-secret-intro .si button:hover { background:#8fd6d3; }
    #cotd-badge-toast { position:fixed; bottom:80px; left:50%; transform:translateX(-50%); background:#150F0B; border:1px solid #6EC3C0; padding:18px 28px; text-align:center; display:none; z-index:400; min-width:260px; }
    #cotd-badge-toast.show { display:block; animation:cotdRankIn 0.4s ease; }
    #cotd-badge-toast .bt-eyebrow { font-family:'Cinzel',serif; font-size:9px; letter-spacing:0.3em; color:#6EC3C0; text-transform:uppercase; margin-bottom:6px; }
    #cotd-badge-toast .bt-badge { font-size:36px; margin-bottom:6px; }
    #cotd-badge-toast .bt-title { font-family:'Playfair Display',serif; font-size:18px; color:#F5F0E8; }
    #cotd-badge-toast .bt-sub { font-family:'Crimson Text',serif; font-style:italic; font-size:13px; color:rgba(245,240,232,0.5); margin-top:4px; }
  `;
  document.head.appendChild(secretStyle);

  const secretIntroEl = document.createElement('div');
  secretIntroEl.id = 'cotd-secret-intro';
  secretIntroEl.innerHTML = `
    <div class="si">
      <div class="eyebrow">Classified Waters</div>
      <div class="shark">🦈</div>
      <h2>The Midnight Drift</h2>
      <p>You shared the haul. The water noticed.<br>These depths aren't on any chart, and they don't hand out easy wins. The Marauder runs here in packs, the tide's already turned against you, and the line's short. Survive the Drift <strong>three times</strong> to earn the Shadow Angler badge for good.</p>
      <p id="cotd-secret-progress" style="font-family:'Cinzel',serif;font-size:11px;letter-spacing:0.15em;color:#6EC3C0;text-transform:uppercase;margin-top:-16px;"></p>
      <button id="cotd-secret-start">Drop In</button>
    </div>
  `;
  document.body.appendChild(secretIntroEl);

  const badgeToastEl = document.createElement('div');
  badgeToastEl.id = 'cotd-badge-toast';
  badgeToastEl.innerHTML = `
    <div class="bt-eyebrow">Badge Unlocked</div>
    <div class="bt-badge">🌑</div>
    <div class="bt-title">Shadow Angler</div>
    <div class="bt-sub">Survived the Midnight Drift</div>
  `;
  document.body.appendChild(badgeToastEl);

  const RANKS = [
    { name: 'Deckhand',        min: 0 },
    { name: 'Mate',            min: 1000 },
    { name: 'Angler',          min: 3000 },
    { name: 'First Mate',      min: 7000 },
    { name: 'Captain',         min: 15000 },
    { name: 'Troubadour Legend', min: 30000 },
    { name: 'Marauder Hunter', min: 60000 }
  ];

  function getRank(points) {
    let current = RANKS[0], next = RANKS[1];
    for (let i = 0; i < RANKS.length; i++) {
      if (points >= RANKS[i].min) { current = RANKS[i]; next = RANKS[i+1] || null; }
    }
    return { current, next };
  }

  function renderRank() {
    const { current, next } = getRank(lifetimeScore);
    document.getElementById('cotd-rank-title').textContent =
      (hasShadowBadge ? '🌑 ' : '') + current.name;
    const fillEl = document.getElementById('cotd-rank-progress-fill');
    if (next) {
      const span = next.min - current.min;
      const progressed = lifetimeScore - current.min;
      fillEl.style.width = Math.min(100, (progressed / span) * 100) + '%';
      document.getElementById('cotd-rank-next').textContent =
        'Next: ' + next.name + ' at ' + next.min.toLocaleString();
    } else {
      fillEl.style.width = '100%';
      document.getElementById('cotd-rank-next').textContent = 'Max Rank Reached';
    }
  }

  function addLifetimeScore(amount) {
    const before = getRank(lifetimeScore).current.name;
    lifetimeScore += amount;
    try { localStorage.setItem('cotd_lifetime_score', String(lifetimeScore)); } catch(e) {}
    const after = getRank(lifetimeScore).current.name;
    renderRank();
    if (after !== before) {
      document.getElementById('cotd-rankup-title').textContent = after;
      rankupEl.classList.add('show');
      setTimeout(() => rankupEl.classList.remove('show'), 2600);
    }
  }

  let playerName = '';
  try { playerName = localStorage.getItem('cotd_player_name') || ''; } catch(e) {}

  function ensurePlayerName() {
    if (playerName) return playerName;
    let entered = '';
    try { entered = window.prompt("What should we call you on the leaderboard?", "") || ''; } catch(e) {}
    entered = entered.trim().slice(0, 24) || 'Angler';
    playerName = entered;
    try { localStorage.setItem('cotd_player_name', playerName); } catch(e) {}
    return playerName;
  }

  async function submitToLeaderboard(currentScore, currentLevel) {
    if (!LEADERBOARD_API_BASE) return null;
    const name = ensurePlayerName();
    try {
      const res = await fetch(LEADERBOARD_API_BASE + '/leaderboard/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ player_name: name, score: currentScore, level: currentLevel, legendary_catches: legendCatches })
      });
      if (!res.ok) return null;
      const data = await res.json();
      return data.rank || null;
    } catch(e) { return null; }
  }

  async function fetchLeaderboard() {
    const listEl = document.getElementById('cotd-leaderboard-list');
    if (!LEADERBOARD_API_BASE) {
      listEl.innerHTML = '<div class="cotd-lb-empty">Leaderboard isn\'t live yet — your best score is still saved on this device.</div>';
      return;
    }
    listEl.innerHTML = '<div class="cotd-lb-empty">Loading the boards…</div>';
    try {
      const res = await fetch(LEADERBOARD_API_BASE + '/leaderboard/top?limit=20');
      const data = await res.json();
      if (!data.entries || !data.entries.length) {
        listEl.innerHTML = '<div class="cotd-lb-empty">No catches logged yet — be the first.</div>';
        return;
      }
      listEl.innerHTML = data.entries.map((e, i) =>
        '<div class="cotd-lb-row"><span class="cotd-lb-rank">#' + (i+1) + '</span>' +
        '<span class="cotd-lb-name">' + escapeHtmlLB(e.player_name) + '</span>' +
        '<span class="cotd-lb-score">' + e.score.toLocaleString() + '</span></div>'
      ).join('');
    } catch(e) {
      listEl.innerHTML = '<div class="cotd-lb-empty">Couldn\'t reach the leaderboard — try again in a moment.</div>';
    }
  }

  function escapeHtmlLB(str) {
    const d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function updateSecretProgressText() {
    const el = document.getElementById('cotd-secret-progress');
    if (!el) return;
    if (hasShadowBadge) {
      el.textContent = '🌑 Shadow Angler earned — the Drift still pays double, no pressure.';
    } else {
      el.textContent = 'Survived: ' + midnightDriftClears + ' / ' + CLEARS_NEEDED_FOR_BADGE;
    }
  }

  try { best = parseInt(localStorage.getItem('cotd_best_score') || '0', 10); } catch(e) {}
  try { level = parseInt(localStorage.getItem('cotd_level') || '1', 10); } catch(e) {}
  try { legendCatches = parseInt(localStorage.getItem('cotd_legend_catches') || '0', 10); } catch(e) {}
  try { legendNextEligibleLevel = parseInt(localStorage.getItem('cotd_legend_next_level') || '1', 10); } catch(e) {}
  try { lifetimeScore = parseInt(localStorage.getItem('cotd_lifetime_score') || '0', 10); } catch(e) {}
  try { hasShadowBadge = localStorage.getItem('cotd_shadow_badge') === '1'; } catch(e) {}
  try { midnightDriftClears = parseInt(localStorage.getItem('cotd_midnight_clears') || '0', 10); } catch(e) {}
  document.getElementById('cotd-legend-total').textContent = legendCatches;
  renderRank();

  let audioCtx = null;
  function chime(freq, dur) {
    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;
      if (!audioCtx) audioCtx = new AC();
      if (audioCtx.state === 'suspended') audioCtx.resume();
      const osc = audioCtx.createOscillator();
      const g = audioCtx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, audioCtx.currentTime);
      g.gain.setValueAtTime(0.15, audioCtx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + dur);
      osc.connect(g); g.connect(audioCtx.destination);
      osc.start(); osc.stop(audioCtx.currentTime + dur);
    } catch(e) {}
  }

  function idx(r, c) { return r * SIZE + c; }
  function randTile() { return Math.floor(Math.random() * TILES.length); }

  function findMatches(b) {
    const matched = new Set();
    for (let r = 0; r < SIZE; r++) {
      let run = 1;
      for (let c = 1; c <= SIZE; c++) {
        if (c < SIZE && b[idx(r,c)] === b[idx(r,c-1)]) { run++; }
        else { if (run >= 3) for (let k = 0; k < run; k++) matched.add(idx(r, c-1-k)); run = 1; }
      }
    }
    for (let c = 0; c < SIZE; c++) {
      let run = 1;
      for (let r = 1; r <= SIZE; r++) {
        if (r < SIZE && b[idx(r,c)] === b[idx(r-1,c)]) { run++; }
        else { if (run >= 3) for (let k = 0; k < run; k++) matched.add(idx(r-1-k, c)); run = 1; }
      }
    }
    return matched;
  }

  function longestRun(matched) {
    let max = 0;
    for (let r = 0; r < SIZE; r++) {
      let run = 0;
      for (let c = 0; c < SIZE; c++) { if (matched.has(idx(r,c))) { run++; max = Math.max(max, run); } else run = 0; }
    }
    for (let c = 0; c < SIZE; c++) {
      let run = 0;
      for (let r = 0; r < SIZE; r++) { if (matched.has(idx(r,c))) { run++; max = Math.max(max, run); } else run = 0; }
    }
    return max;
  }

  function genBoard() {
    let b;
    do { b = new Array(SIZE * SIZE).fill(0).map(randTile); } while (findMatches(b).size > 0);
    return b;
  }

  function setGoalForLevel() {
    goalType = (level - 1) % TILES.length;
    goalTarget = 12 + Math.floor((level - 1) / TILES.length) * 4 + (level - 1) * 1;
    goalProgress = 0;
    moves = 20 + Math.floor(level / 3);
    reverseTide = false;
    movesSinceTideFlip = 0;
    trophyAt = -1;
    trophyCooldown = 2;
    tension = 0;
    hotReelMovesLeft = 0;
    legendAt = -1;
    legendSpawnedThisLevel = false;
  }

  function setSecretLevelGoal() {
    goalType = Math.floor(Math.random() * TILES.length);
    goalTarget = 35;
    goalProgress = 0;
    moves = 14;
    reverseTide = true;
    movesSinceTideFlip = 0;
    trophyAt = -1;
    trophyCooldown = 0;
    tension = 0;
    hotReelMovesLeft = 0;
    legendAt = -1;
    legendSpawnedThisLevel = false;
    preSecretLegendNextEligibleLevel = legendNextEligibleLevel;
    legendNextEligibleLevel = 0;
  }

  function maybeSpawnTrophy() {
    if (trophyAt === -1 && trophyCooldown <= 0) {
      trophyAt = Math.floor(Math.random() * SIZE * SIZE);
      trophyCooldown = inSecretLevel ? 1 : 3;
    }
  }

  function swimTrophy() {
    if (trophyAt === -1) return;
    const r = Math.floor(trophyAt / SIZE), c = trophyAt % SIZE;
    const dirs = [[-1,0],[1,0],[0,-1],[0,1]].filter(([dr,dc]) => {
      const nr = r+dr, nc = c+dc;
      return nr >= 0 && nr < SIZE && nc >= 0 && nc < SIZE;
    });
    const [dr, dc] = dirs[Math.floor(Math.random() * dirs.length)];
    trophyAt = idx(r+dr, c+dc);
  }

  function maybeSpawnLegend() {
    if (legendAt !== -1 || legendSpawnedThisLevel) return;
    if (level < legendNextEligibleLevel && !inSecretLevel) return;
    const spawnChance = inSecretLevel ? 0.18 : 0.04;
    if (Math.random() < spawnChance) {
      let spot;
      do { spot = Math.floor(Math.random() * SIZE * SIZE); } while (spot === trophyAt);
      legendAt = spot;
      legendSpawnedThisLevel = true;
    }
  }

  function render() {
    boardEl.innerHTML = '';
    boardEl.classList.toggle('reverse', reverseTide);
    const root = document.getElementById('cotd-root');
    if (inSecretLevel) root.classList.add('secret-mode');
    else root.classList.remove('secret-mode');

    board.forEach((t, i) => {
      const d = document.createElement('div');
      const isTrophy = i === trophyAt, isLegend = i === legendAt;
      d.className = 'cotd-tile' + (isTrophy ? ' trophy' : '') + (isLegend ? ' legend' : '');
      d.textContent = isLegend ? LEGEND_ICON : (isTrophy ? TROPHY : TILES[t]);
      d.dataset.i = i;
      d.addEventListener('click', onTileClick);
      boardEl.appendChild(d);
    });

    document.getElementById('cotd-level').textContent = inSecretLevel ? '🌑' : level;
    document.getElementById('cotd-moves').textContent = moves;
    document.getElementById('cotd-score').textContent = score;
    document.getElementById('cotd-best').textContent = best;
    document.getElementById('cotd-legend-total').textContent = legendCatches;

    let goalText = inSecretLevel
      ? '🌑 Midnight Drift — collect ' + goalTarget + ' ' + TILES[goalType] + '  (' + goalProgress + '/' + goalTarget + ')'
      : 'Goal: collect ' + goalTarget + ' ' + TILES[goalType] + '  (' + goalProgress + '/' + goalTarget + ')';
    if (secretMultiplierActive && !inSecretLevel) goalText += '   🌑 2× Shadow Multiplier active';
    if (legendAt > -1) goalText += '   🦈 The Marauder is running — land it now!';
    else if (trophyAt > -1) goalText += '   🏆 Trophy Fish is loose — catch it!';
    document.getElementById('cotd-goal').textContent = goalText;

    tideFlagEl.textContent = reverseTide ? '↑ Reverse Tide — tiles rise up' : '↓ Normal Tide — tiles fall down';
    hotReelEl.classList.toggle('active', hotReelMovesLeft > 0);
    tensionFillEl.style.width = Math.min(100, (tension / TENSION_MAX) * 100) + '%';
    tensionPctEl.textContent = Math.round(Math.min(100, (tension / TENSION_MAX) * 100)) + '%';
  }

  function showCombo(text) {
    comboEl.textContent = text;
    comboEl.classList.remove('show');
    void comboEl.offsetWidth;
    comboEl.classList.add('show');
  }

  function triggerLegendaryCatch(catchIndex) {
    const r = Math.floor(catchIndex / SIZE), c = catchIndex % SIZE;
    const cleared = new Set();
    for (let cc = 0; cc < SIZE; cc++) cleared.add(idx(r, cc));
    for (let rr = 0; rr < SIZE; rr++) cleared.add(idx(rr, c));
    let bonus = inSecretLevel ? 2000 : 1000;
    if (secretMultiplierActive && !inSecretLevel) bonus *= 2;
    cleared.forEach(i => { if (board[i] === goalType) goalProgress++; });
    score += bonus;
    addLifetimeScore(bonus);
    legendCatches++;
    if (!inSecretLevel) {
      legendNextEligibleLevel = level + 5;
      try { localStorage.setItem('cotd_legend_next_level', String(legendNextEligibleLevel)); } catch(e) {}
    }
    try { localStorage.setItem('cotd_legend_catches', String(legendCatches)); } catch(e) {}
    chime(220, 0.5); chime(330, 0.5);
    document.getElementById('cotd-legend-score').textContent =
      '+' + bonus + ' points · full row & column cleared' + (inSecretLevel ? ' · MIDNIGHT BONUS' : '');
    legendOverlayEl.classList.add('active');
    return cleared;
  }

  async function resolveCascade() {
    let combo = 0;
    while (true) {
      let matched = findMatches(board);
      let legendaryTriggered = false;
      if (matched.has(legendAt) && legendAt > -1) {
        const crossCleared = triggerLegendaryCatch(legendAt);
        crossCleared.forEach(i => matched.add(i));
        legendAt = -1;
        legendaryTriggered = true;
      }
      if (matched.size === 0) break;
      combo++;
      const runLen = longestRun(matched);
      let gained = 0;
      matched.forEach(i => { if (board[i] === goalType) goalProgress++; gained += 10 * combo; });
      if (matched.has(trophyAt) && trophyAt > -1) {
        goalProgress += 3; gained += 150; trophyAt = -1; trophyCooldown = inSecretLevel ? 1 : 3;
      }
      if (hotReelMovesLeft > 0) { gained *= 2; }
      if (inSecretLevel) { gained = Math.floor(gained * 1.5); }
      if (secretMultiplierActive && !inSecretLevel) { gained *= 2; }
      if (runLen >= 4) { tension = 0; hotReelMovesLeft = 2; }
      score += gained;
      addLifetimeScore(gained);
      const tiles = Array.from(boardEl.children);
      matched.forEach(i => tiles[i] && tiles[i].classList.add('pop'));
      chime(inSecretLevel ? 220 + combo * 40 : 440 + combo * 60, 0.18);
      if (combo > 1 && !legendaryTriggered) showCombo(combo + 'x Combo!  +' + gained);
      await new Promise(r => setTimeout(r, legendaryTriggered ? 500 : 220));

      for (let c = 0; c < SIZE; c++) {
        if (!reverseTide) {
          let write = SIZE - 1;
          for (let r = SIZE - 1; r >= 0; r--) {
            if (!matched.has(idx(r, c))) { board[idx(write, c)] = board[idx(r, c)]; write--; }
          }
          for (let r = write; r >= 0; r--) board[idx(r, c)] = randTile();
        } else {
          let write = 0;
          for (let r = 0; r < SIZE; r++) {
            if (!matched.has(idx(r, c))) { board[idx(write, c)] = board[idx(r, c)]; write++; }
          }
          for (let r = write; r < SIZE; r++) board[idx(r, c)] = randTile();
        }
      }
      render();
      const newTiles = Array.from(boardEl.children);
      newTiles.forEach(t => t.classList.add('drop'));
      await new Promise(r => setTimeout(r, 200));
    }
    if (hotReelMovesLeft > 0) hotReelMovesLeft--;
    checkLevelState();
  }

  function checkLevelState() {
    if (goalProgress >= goalTarget) {
      if (score > best) { best = score; try { localStorage.setItem('cotd_best_score', String(best)); } catch(e) {} }

      if (inSecretLevel) {
        inSecretLevel = false;
        secretMultiplierActive = true;
        legendNextEligibleLevel = preSecretLegendNextEligibleLevel;
        midnightDriftClears++;
        try { localStorage.setItem('cotd_midnight_clears', String(midnightDriftClears)); } catch(e) {}

        let overlayText;
        if (!hasShadowBadge && midnightDriftClears >= CLEARS_NEEDED_FOR_BADGE) {
          hasShadowBadge = true;
          try { localStorage.setItem('cotd_shadow_badge', '1'); } catch(e) {}
          badgeToastEl.classList.add('show');
          setTimeout(() => badgeToastEl.classList.remove('show'), 4000);
          overlayText = 'Three times through the dark water, and it finally recognizes you. You carry a 2× point multiplier into the next level — and the Shadow Angler badge is yours for good.';
        } else if (!hasShadowBadge) {
          overlayText = 'The water gives back what it takes — this time. You carry a 2× point multiplier into the next level. Survive the Drift ' + (CLEARS_NEEDED_FOR_BADGE - midnightDriftClears) + ' more time(s) to earn the Shadow Angler badge for good.';
        } else {
          overlayText = 'The water gives back what it takes. You carry a 2× point multiplier into the next level.';
        }

        document.getElementById('cotd-root').classList.remove('secret-mode');
        render();
        showOverlay(
          '🌑 Midnight Drift Survived',
          overlayText,
          'Back to the Surface',
          () => { setGoalForLevel(); board = genBoard(); locked = false; render(); }
        );
        return;
      }

      level++;
      try { localStorage.setItem('cotd_level', String(level)); } catch(e) {}
      const clearedScore = score, clearedLevel = level - 1;
      const multiplierWasActive = secretMultiplierActive;
      secretMultiplierActive = false;
      render();
      submitToLeaderboard(clearedScore, clearedLevel).then((rank) => {
        const rankNote = rank ? ' You\'re currently #' + rank + ' on the leaderboard.' : '';
        const multNote = multiplierWasActive ? ' 🌑 Shadow Multiplier applied — that level paid double.' : '';
        showOverlay(
          'Level Cleared!',
          'Nice haul — moving to level ' + level + '.' + rankNote + multNote,
          'Next Level',
          () => { setGoalForLevel(); board = genBoard(); locked = false; render(); }
        );
      });
      return;
    } else if (moves <= 0) {
      if (score > best) { best = score; try { localStorage.setItem('cotd_best_score', String(best)); } catch(e) {} }
      if (inSecretLevel) {
        inSecretLevel = false;
        legendNextEligibleLevel = preSecretLegendNextEligibleLevel;
        document.getElementById('cotd-root').classList.remove('secret-mode');
        showOverlay('The Drift Took You', 'The midnight water doesn\'t forgive. Surface and try again.', 'Back to the Surface', () => {
          setGoalForLevel(); board = genBoard(); locked = false; render();
        });
      } else {
        showOverlay('Out of Moves', 'So close — give this haul another run.', 'Retry Level', () => {
          setGoalForLevel(); board = genBoard(); locked = false; render();
        });
      }
    } else {
      locked = false;
    }
    render();
  }

  function showOverlay(title, text, btnLabel, onGo) {
    document.getElementById('cotd-overlay-title').textContent = title;
    document.getElementById('cotd-overlay-text').textContent = text;
    const btn = document.getElementById('cotd-overlay-btn');
    btn.textContent = btnLabel;
    overlayEl.classList.add('active');
    btn.onclick = () => { overlayEl.classList.remove('active'); onGo(); };
  }

  document.getElementById('cotd-legend-close').addEventListener('click', () => {
    legendOverlayEl.classList.remove('active');
  });

  function areAdjacent(a, b) {
    const ra = Math.floor(a/SIZE), ca = a%SIZE, rb = Math.floor(b/SIZE), cb = b%SIZE;
    return (ra === rb && Math.abs(ca-cb) === 1) || (ca === cb && Math.abs(ra-rb) === 1);
  }

  async function onTileClick(e) {
    if (locked || tutorialActive) return;
    const i = parseInt(e.currentTarget.dataset.i, 10);
    if (selected === null) { selected = i; e.currentTarget.classList.add('sel'); return; }
    if (selected === i) { e.currentTarget.classList.remove('sel'); selected = null; return; }
    if (!areAdjacent(selected, i)) {
      Array.from(boardEl.children)[selected].classList.remove('sel');
      selected = i; e.currentTarget.classList.add('sel'); return;
    }
    locked = true;
    const tmp = board[selected];
    board[selected] = board[i];
    board[i] = tmp;
    const matched = findMatches(board);
    const specialSwap = selected === trophyAt || i === trophyAt || selected === legendAt || i === legendAt;
    if (matched.size === 0 && !specialSwap) {
      board[i] = board[selected]; board[selected] = tmp;
      render(); selected = null; locked = false; return;
    }
    if (selected === trophyAt) trophyAt = i; else if (i === trophyAt) trophyAt = selected;
    if (selected === legendAt) legendAt = i; else if (i === legendAt) legendAt = selected;
    selected = null;
    moves--;
    tension++;
    movesSinceTideFlip++;
    trophyCooldown--;
    maybeSpawnTrophy();
    maybeSpawnLegend();
    if (trophyAt > -1 && matched.size === 0) swimTrophy();
    if (movesSinceTideFlip >= 6) {
      reverseTide = !reverseTide; movesSinceTideFlip = 0;
      showCombo(reverseTide ? 'Tide Turns! Reverse' : 'Tide Turns! Normal');
    }
    if (tension >= TENSION_MAX) { tension = 0; goalTarget += 1; showCombo('Lost the Fish! Line Snapped'); }

    render();
    if (tutorialStep === 4) advanceTutorial();
    await resolveCascade();
  }

  document.getElementById('cotd-restart').addEventListener('click', () => {
    score = 0;
    if (inSecretLevel) legendNextEligibleLevel = preSecretLegendNextEligibleLevel;
    inSecretLevel = false;
    document.getElementById('cotd-root').classList.remove('secret-mode');
    setGoalForLevel(); board = genBoard(); locked = false; render();
  });

  const lbPanel = document.getElementById('cotd-leaderboard-panel');
  document.getElementById('cotd-leaderboard-btn').addEventListener('click', () => {
    lbPanel.classList.add('active');
    fetchLeaderboard();
  });
  document.getElementById('cotd-leaderboard-close').addEventListener('click', () => {
    lbPanel.classList.remove('active');
  });

  document.getElementById('cotd-share-btn').addEventListener('click', async () => {
    const { current } = getRank(lifetimeScore);
    const rank = await submitToLeaderboard(score, level);
    const rankText = rank ? (' I\'m #' + rank + ' on the leaderboard.') : '';
    const badgeText = hasShadowBadge ? ' 🌑 Shadow Angler.' : '';
    const text = 'I just hit Level ' + level + ' as a ' + current.name +
      ' in SaltWater Troubadour\'s Catch of the Day —' + rankText +
      ' ' + legendCatches + ' legendary catch(es) landed.' + badgeText +
      ' Think you can beat me?';
    const url = window.location.href;

    let shared = false;
    if (navigator.share) {
      try { await navigator.share({ title: 'Catch of the Day', text: text, url: url }); shared = true; } catch(e) {}
    }
    if (!shared) {
      try {
        await navigator.clipboard.writeText(text + ' ' + url);
        showCombo('Copied to Clipboard!');
        shared = true;
      } catch(e) {
        showCombo('Share: ' + text);
        shared = true;
      }
    }

    if (shared && !shareUsedThisSession) {
      shareUsedThisSession = true;
      addLifetimeScore(500);
      score += 500;
      showCombo('+500 Share Bonus — Classified Waters Unlocked 🌑');
      secretLevelPending = true;
      setTimeout(() => {
        updateSecretProgressText();
        secretIntroEl.classList.add('active');
      }, 1800);
    }
  });

  document.getElementById('cotd-secret-start').addEventListener('click', () => {
    secretIntroEl.classList.remove('active');
    secretLevelPending = false;
    inSecretLevel = true;
    setSecretLevelGoal();
    board = genBoard();
    locked = false;
    render();
  });

  let tutorialActive = false;
  let tutorialStep = 0;
  const TUT_STEPS = [
    { icon: '🎣', title: 'Welcome, Angler', text: 'Swap two neighboring tiles to line up 3 or more of the same catch. Let\'s walk the deck before you set sail.' },
    { icon: '🌊', title: 'The Tide Turns', text: 'Every few moves, the tide flips — the whole board flows the opposite direction. Plan your swaps with the current, not against it.' },
    { icon: '🏆', title: 'Trophy Fish', text: 'A golden Trophy Fish will surface on the board. It swims to a new spot if you don\'t catch it — match it fast for a big bonus.' },
    { icon: '📈', title: 'Line Tension', text: 'Every ordinary move tightens your line. Land a big match of 4 or more to release the tension and trigger Hot Reel — double score for two moves.' },
    { icon: '👉', title: 'Try It Yourself', text: 'Tap a highlighted tile, then tap its glowing neighbor to make your first real match.' }
  ];

  function showTutorialStep() {
    const s = TUT_STEPS[tutorialStep];
    document.getElementById('cotd-tut-eyebrow').textContent = 'Step ' + (tutorialStep+1) + ' of ' + TUT_STEPS.length;
    document.getElementById('cotd-tut-icon').textContent = s.icon;
    document.getElementById('cotd-tut-title').textContent = s.title;
    document.getElementById('cotd-tut-text').textContent = s.text;
    const nextBtn = document.getElementById('cotd-tut-next');
    if (tutorialStep === TUT_STEPS.length - 1) {
      nextBtn.style.display = 'none';
      tutorialEl.classList.remove('active');
      highlightFirstMove();
    } else {
      nextBtn.style.display = 'inline-block';
      tutorialEl.classList.add('active');
    }
  }

  function highlightFirstMove() {
    for (let i = 0; i < SIZE * SIZE; i++) {
      const r = Math.floor(i/SIZE), c = i%SIZE;
      const neighbors = [idx(r, c+1), idx(r+1, c)].filter(n =>
        n < SIZE * SIZE && (Math.floor(n/SIZE) === r || n%SIZE === c)
      );
      for (const n of neighbors) {
        const tmp = board[i]; board[i] = board[n]; board[n] = tmp;
        const hasMatch = findMatches(board).size > 0;
        board[n] = board[i]; board[i] = tmp;
        if (hasMatch) {
          const tiles = Array.from(boardEl.children);
          if (tiles[i]) tiles[i].classList.add('coach');
          if (tiles[n]) tiles[n].classList.add('coach');
          return;
        }
      }
    }
  }

  function advanceTutorial() {
    tutorialActive = false;
    try { localStorage.setItem('cotd_tutorial_done', '1'); } catch(e) {}
  }

  document.getElementById('cotd-tut-next').addEventListener('click', () => {
    tutorialStep++;
    showTutorialStep();
  });
  document.getElementById('cotd-tut-skip').addEventListener('click', () => {
    tutorialEl.classList.remove('active');
    tutorialActive = false;
    try { localStorage.setItem('cotd_tutorial_done', '1'); } catch(e) {}
  });

  setGoalForLevel();
  board = genBoard();
  render();

  let tutorialDone = false;
  try { tutorialDone = localStorage.getItem('cotd_tutorial_done') === '1'; } catch(e) {}
  if (!tutorialDone) {
    tutorialActive = true;
    tutorialStep = 0;
    showTutorialStep();
  }
})();
